export default {
      id: "special_room1-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#special_room1",
      toString: function () {
        return this.url;
      }
    }